import React from 'react';
import {
  EditorState, AtomicBlockUtils, SelectionState, Modifier, CompositeDecorator
} from 'draft-js';

// localstorage
export const getToken = () => localStorage.getItem('token');
export const addToken = token => localStorage.setItem('token', token);
export const removeToken = () => localStorage.removeItem('token');

// validator
export const isJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const tryParseJSON = (str) => {
  try {
    const parsed = JSON.parse(str);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (parsed && typeof parsed === 'object') {
      return parsed;
    }
  // eslint-disable-next-line no-empty
  } catch (e) { }
  return false;
}

// Draftjs

const Link = ({ entityKey, contentState, children }) => {
  let { url, title } = contentState.getEntity(entityKey).getData();
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      href={url}
    >
      {children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

export const createLinkDecorator = () => new 
CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);

// Solução ao problema https://stackoverflow.com/questions/62321505/how-to-add-link-in-draft-js-no-plugins
export const insertLink = (editorState, onChange, { type, data }) => {
  const decorator = createLinkDecorator();

  const currentContent = editorState.getCurrentContent();
  const createEntity = currentContent.createEntity(type, 'MUTABLE', data);
  let entityKey = currentContent.getLastCreatedEntityKey();
  const selection = editorState.getSelection();
  const textWithEntity = Modifier.insertText(
    currentContent,
    selection,
    data.title,
    null,
    entityKey
  );
  let newState = EditorState.createWithContent(textWithEntity, decorator);
  onChange(newState);
}

export const insertBlock = (editorState, onChange, { type, data }) => {
  // create an entity
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity(
    type,
    'IMMUTABLE',
    data,
  );
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const newEditorState = EditorState.set(
    editorState,
    { currentContent: contentStateWithEntity }
  );

  // insert a new atomic block with entity metadata
  const text = ' '
  const newEditorStateWithBlock = AtomicBlockUtils.insertAtomicBlock(
    newEditorState,
    entityKey,
    text
  );
  onChange(newEditorStateWithBlock)
}

export const insertMarkdown = (editorState, onChange, { markdown }) => {

  // Get the current ContentState and SelectionState
  const currentContent = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  // Create a new ContentState with the Markdown text inserted at the current cursor position
  const newContentState = Modifier.insertText(
    currentContent,
    selectionState,
    markdown,
    null,
    null
  );

  // Create a new EditorState with the modified content
  const newEditorState = EditorState.push(
    editorState,
    newContentState
  );

  onChange(newEditorState);
}

export const insertBlockUrl = (editorState, onChange, { type, data }) => {
  // const decorator = createLinkDecorator();
  let link = 'http://www.google.com';
  const currentContent = editorState.getCurrentContent();
  const contentStateWithEntity = currentContent.createEntity(
    'LINK',
    'MUTABLE',
    data
  );
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const selection = editorState.getSelection();

  const textWithEntity = Modifier.replaceText(
    contentStateWithEntity,
    selection,
    entityKey
  )
  const text = 'teste'
  const newState = EditorState.createWithContent(
    textWithEntity,
    // createLinkDecorator()
  );
  

  onChange(newState)
}

export const removeBlock = ({
  editorState, contentState, block,
}) => {
  const keyAfter = contentState.getKeyAfter(block.getKey())
    || contentState.getKeyBefore(block.getKey());
  const withoutAtomicEntity = Modifier.removeRange(
    contentState,
    new SelectionState({
      anchorKey: block.getKey(),
      anchorOffset: 0,
      focusKey: block.getKey(),
      focusOffset: block.getLength(),
    }),
    'backward',
  );
  const blockMap = withoutAtomicEntity.getBlockMap().delete(block.getKey());
  const withoutAtomic = withoutAtomicEntity.merge({
    blockMap,
    selectionAfter: SelectionState.createEmpty(keyAfter)
    ,
  });

  const newEditorState = EditorState.push(editorState, withoutAtomic, 'remove-range');
  return newEditorState
};

export const editBlockEntity = ({
  editorState, contentState, entityKey, newData,
}) => {
  const newContentState = contentState.replaceEntityData(entityKey, newData)
  const newEditorState = EditorState.push(editorState, newContentState)
  return newEditorState
}

export const isPathAbsolute = (path) => /^(?:\/|[a-z]+:\/\/)/.test(path)
export const isPathEditor = (path) => {
  const splitUrl = path.split('/');
  const isEditor = splitUrl.includes('editor') && splitUrl.includes('page');
  return isEditor
}

/**
* Utility function to execute callback for each key->value pair.
*/
export function forEach(obj, callback) {
  if (obj) {
    for (const key in obj) { // eslint-disable-line no-restricted-syntax
      if ({}.hasOwnProperty.call(obj, key)) {
        callback(key, obj[key]);
      }
    }
  }
}

export const exportExcel = async (res, filename) => {
  // use this after api call to download the file
  const fileName = `${filename}.xlsx`
  const byteArray = res.data
  const url = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  const link = document.createElement('a')
  link.href = url
  link.setAttribute(
    'download',
    fileName
  )
  document.body.appendChild(link);
  link.click()
  link.parentNode?.removeChild(link)
}
